<script lang="ts">
  import type {
    IFormDropdownNode,
    PartialNode,
  } from "@shared/common/node/type";
  import { generateFormDataName } from "@shared/common/utils/form";
  import detectReaction from "../../actions/detect-reaction";
  import { getCurrentDocumentNode, getStore } from "../../context";
  import FormLabel from "./form/form-label.svelte";

  const { reactionEventListener } = getStore();

  const documentNode = getCurrentDocumentNode();

  export let node: PartialNode<IFormDropdownNode>;

  $: name = generateFormDataName(node);
</script>

<div
  use:detectReaction={{
    node,
    onAction: reactionEventListener,
    documentNode,
  }}
>
  <FormLabel label={node.label} required={node.required} htmlFor={node.id} />
  <div class="dropdown">
    <select id={node.id} {name} required={node.required}>
      <option hidden={node.required} value="" data-is-placeholder>
        {node.placeholder}
      </option>
      {#each node.items || [] as item}
        <option value={`${item.label}#${item.id}`}>
          {item.label}
        </option>
      {/each}
    </select>
    <svg
      class="dropdown-chevron"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"><path d="m6 9 6 6 6-6" /></svg
    >
  </div>
</div>

<style>
  /* 참고: front-app 의 editor-node 스타일도 함께 수정 필요 */
  .dropdown select {
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    padding: calc(var(--cb-text-xl) * 0.5) var(--cb-text-sm);
    width: 100%;
    height: 48px;
    outline: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .dropdown {
    position: relative;
    border-width: 1px;
    border-style: solid;
    border-color: rgba(var(--cb-form-base-color), 1);
    transition-property: border-color;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
    border-radius: 4px;
    box-sizing: border-box;
    font-size: var(--cb-text-lg);
    line-height: var(--cb-line-height-xl);
    color: rgba(var(--cb-form-font-color), 1);
    background-color: white;
    margin-top: calc(var(--cb-form-font-size) * 0.5);
  }

  .dropdown select:has(option[data-is-placeholder]:checked) {
    color: rgba(var(--cb-form-font-color), 0.6);
  }

  .dropdown:hover,
  .dropdown:has(select:focus) {
    border-color: rgba(var(--cb-form-primary-color), 0.5);
  }

  .dropdown-chevron {
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    right: calc(var(--cb-form-font-size) * 0.75);
    width: calc(var(--cb-form-font-size) * 1.2);
    height: calc(var(--cb-form-font-size) * 1.2);
    border-radius: 50%;
    color: rgba(var(--cb-form-font-color), 0.7);
    pointer-events: none;
  }
</style>
